import React, { useState } from 'react';
import { useNotifications } from '../../contexts/NotificationContext';
import NotificationItem from './NotificationItem';

const isToolEvent = (n) =>
  typeof n.notification_type === 'string' && n.notification_type.startsWith('tool_');

const NotificationDropdown = ({ onClose }) => {
  const { notifications, unreadCount, loading, markAllRead } = useNotifications();
  const [filter, setFilter] = useState('all'); // 'all' | 'tools'

  const handleMarkAllRead = async (e) => {
    e.preventDefault();
    await markAllRead();
  };

  const filtered = filter === 'tools' ? notifications.filter(isToolEvent) : notifications;
  const toolCount = notifications.filter(isToolEvent).length;

  return (
    <div className="notification-dropdown">
      <div className="notification-dropdown-header">
        <h6 className="mb-0">Notificaciones</h6>
        {unreadCount > 0 && (
          <button className="btn btn-link btn-sm p-0 text-decoration-none" onClick={handleMarkAllRead}>
            Marcar todas como leídas
          </button>
        )}
      </div>

      {toolCount > 0 && (
        <div className="d-flex gap-1 px-2 py-2 border-bottom">
          <button
            type="button"
            className={`btn btn-sm ${filter === 'all' ? 'btn-primary' : 'btn-outline-secondary'} flex-grow-1`}
            onClick={() => setFilter('all')}
            style={{ fontSize: '0.8rem', padding: '0.15rem 0.5rem' }}
          >
            Todas ({notifications.length})
          </button>
          <button
            type="button"
            className={`btn btn-sm ${filter === 'tools' ? 'btn-primary' : 'btn-outline-secondary'} flex-grow-1`}
            onClick={() => setFilter('tools')}
            style={{ fontSize: '0.8rem', padding: '0.15rem 0.5rem' }}
          >
            <i className="bi bi-tools me-1" />
            Herramientas ({toolCount})
          </button>
        </div>
      )}

      <div className="notification-dropdown-body">
        {loading && notifications.length === 0 ? (
          <div className="notification-empty">
            <div className="spinner-border spinner-border-sm text-primary" role="status">
              <span className="visually-hidden">Cargando...</span>
            </div>
          </div>
        ) : filtered.length === 0 ? (
          <div className="notification-empty">
            <i className="bi bi-bell-slash text-muted" style={{ fontSize: '2rem' }}></i>
            <p className="text-muted mt-2 mb-0">
              {filter === 'tools' ? 'Sin eventos de herramientas' : 'No hay notificaciones'}
            </p>
          </div>
        ) : (
          filtered.slice(0, 20).map(notification => (
            <NotificationItem
              key={notification.id}
              notification={notification}
              onClose={onClose}
            />
          ))
        )}
      </div>
    </div>
  );
};

export default NotificationDropdown;
